import {
    getAuthenticated,
    putAuthenticated
} from '../../../../services/RestTemplate';
import { objToUrlParams } from '../../../../shared/helpers/url-params.helper';

const rulesUrl = '/rules';

export function getRulesByCategory(args) {
    const urlParams = objToUrlParams(args);
    const getRulesUrl = rulesUrl + urlParams;

    return getAuthenticated(getRulesUrl);
}

export function updateRule(ruleId, ruleConfig) {
    const updateRuleUrl = rulesUrl + '/' + ruleId;

    return putAuthenticated(updateRuleUrl, { ruleConfig });
}

export function updateRuleStatus(ruleId, enabled) {
    const updateRuleUrl = rulesUrl + '/' + ruleId;

    return putAuthenticated(updateRuleUrl, { enabled });
}
